module.exports = __webpack_public_path__ + "img/aidtools_introduce.2d57189a.png";